import { useMemo } from "react";

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: "Builder Block",
    entityNamePlural: "Builder Blocks",
    entityNameModule: "cms",
    basePath: "/cms/builder-blocks",
  }), [])
}
